import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://upkjgxidqqrpeeflpxtz.supabase.co';
const supabaseAnonKey = 'sb_publishable_FTwMKhPie_GEceVQT2Td4Q_kesRB6Nq';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
